export const SYSTEM_CATEGORY = "system";